import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import {
    useNotify,
    useUpdate,
    useRefresh,
    useRecordContext,
    useTranslate,
} from "react-admin";
import { handleHttpError } from "shared/src/utils/errorHandler";
import { CarnetForm } from "./CarnetForm";

export const EditCarnetDialog = ({
    record,
    isAdditionalRow,
    setEditCarnetItem,
    index,
}) => {
    const [update] = useUpdate();
    const notify = useNotify();
    const refresh = useRefresh();
    const translate = useTranslate();
    const rental = useRecordContext();

    const onSave = (data) => {
        if (isAdditionalRow) {
            const updatedCarnetData = rental.carnetData.map((item, i) => {
                if (rental.carnetData.length - i - 1 === index) {
                    return data;
                }
                return item;
            });
            update(
                "rentals",
                {
                    id: rental.id,
                    data: {
                        carnetData: updatedCarnetData,
                    },
                },
                {
                    onSettled: () => {
                        setEditCarnetItem(null);
                        refresh();
                    },
                    onError: (e) => {
                        handleHttpError(e, notify);
                    },
                }
            );
        } else {
            const { quantity, weight, carnetPrice } = data;
            update(
                "rentalItems",
                {
                    id: record.id,
                    data: { carnetData: { quantity, weight, carnetPrice } },
                },
                {
                    onSettled: () => {
                        setEditCarnetItem(null);
                        refresh();
                    },
                    onError: (e) => {
                        handleHttpError(e, notify);
                    },
                }
            );
        }
    };

    const onCancel = () => {
        setEditCarnetItem(null);
    };

    return (
        <Dialog fullWidth open={true}>
            <DialogTitle>{translate("equip.editCarnetItem")}</DialogTitle>
            <DialogContent>
                <CarnetForm
                    onCancel={onCancel}
                    onSave={onSave}
                    record={record}
                    action="edit"
                    isAdditionalRow={isAdditionalRow}
                />
            </DialogContent>
        </Dialog>
    );
};
